import { AuditAlerts } from "modules/auditLog";

const AuditAlertsPage = () => {
  return <AuditAlerts />;
};

export default AuditAlertsPage;
